import { render } from "./pairing-show.vue?vue&type=template&id=36caa2d2&lang=pug"
import script from "./pairing-show.vue?vue&type=script&lang=js"
export * from "./pairing-show.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__